import { render, staticRenderFns } from "./savings.vue?vue&type=template&id=f54cb054&scoped=true"
import script from "./savings.vue?vue&type=script&lang=js"
export * from "./savings.vue?vue&type=script&lang=js"
import style0 from "./savings.vue?vue&type=style&index=0&id=f54cb054&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f54cb054",
  null
  
)

export default component.exports